import {
  storyblokEditable,
  StoryblokComponent,
  renderRichText,
} from "@storyblok/react"
import { motion } from "framer-motion"

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 0.05 },
  },
}

export default function Tiers({ blok }: any) {
  return (
    <section
      {...storyblokEditable(blok)}
      className="relative pt-24 pb-28 px-6 md:px-12 bg-white"
    >
      <div className="absolute bottom-0 left-0 w-full h-16 bg-[#37d3a1]" />

      <div className="max-w-6xl mx-auto relative z-10">
        {blok.heading && (
          <div
            className="font-['BeausiteClassic'] font-bold text-[24px] md:text-[32px] text-center text-gray-900 mb-12"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.heading || { content: [] }) || "",
            }}
          />
        )}

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          className="grid gap-8 md:gap-10 grid-cols-1 md:grid-cols-3 items-stretch"
        >
          {blok.tiers?.map((nestedBlok: any) => (
            <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))}
        </motion.div>
      </div>
    </section>
  )
}
